angular.module('app.filters').filter('twitterSettings', () =>
    function(settings) {
        if (settings && settings.twitter_display_name && settings.share_url) {
            let url = null;
            if (settings.share_url) {
                url = settings.share_url;
            }

            let tweeted = true;
            if (settings.should_not_tweet) {
                tweeted = !settings.should_not_tweet;
            }

            let byWhom = null;
            if (settings.twitter_display_name) {
                byWhom = settings.twitter_display_name;
            }

            return `Twitter: ${url ? `<a href="${url}" target="_blank">` : ''}Linked${tweeted ? ' and tweeted' : ''}${byWhom ? ` by ${byWhom}` : ''}${url ? "</a>" : ''}`;
        } else {
            return 'Twitter: Not linked';
        }
    }
);


// WEBPACK FOOTER //
// ./filters/twitter_settings.js